export function shouldShowBigHoverAction(action: string, canDelete: boolean) {
    switch (action) {
        case 'Delete':
            return canDelete;
        case 'Archive': // TODO add check for when to showArchive
            return true;
    }
    return null;
}
